import { React } from "react";
import { Row } from "reactstrap";

const PricingSection = ({
  currency,
  finalPrice,
  basePrice,
  appliedCharges,
}) => {

  return (
    <Row className="d-flex flex-column my-0 px-0 bg-site-white mt-3">
      <div className="d-flex py-2 justify-content-between align-items-center">
        <span className="text-muted">Order Price</span>
        <span className="text-muted">
          {currency || "$"}&nbsp;{basePrice}
        </span>
      </div>

      {appliedCharges && appliedCharges?.length > 0 && (
        <div className="d-flex flex-column py-2">
          {appliedCharges.map((charge, index) => (
            <div
              key={index}
              className="d-flex justify-content-between align-items-center mb-2"
            >
              <span className="text-muted">
                {charge.name} (
                {charge.type === "fixed"
                  ? `${currency} ${charge.fee}`
                  : `${charge.fee}%`}
                )
              </span>
              <span className="text-muted">
                + {currency} {charge.addedAmount}
              </span>
            </div>
          ))}
        </div>
      )}

      <div className="d-flex py-3 justify-content-between align-items-center cart__shipping_pricing border-top border-lighter mt-2 pt-2">
        <h5 className="price_heading">Total Price</h5>
          <span className="custom-price-color">{currency || "$"}&nbsp;{finalPrice}</span>
      </div>
    </Row>
  );
};

export default PricingSection;
